import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { ProverbComponent } from './proverb.component';


const routes: Routes = [
  {
    path: 'proverb/:type',
    component: ProverbComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class ProverbRoutingModule {}
